import React, { useState, useEffect } from 'react';

import { Table } from 'antd';

const SummaryTable = ({ formData }) => {
    const cols = [
        {
            title: '',
            dataIndex: 'rowHeader',
            width: '15%',
        },
        {
            title: 'Rooms',
            dataIndex: 'rooms',
            width: '10%',
        },
        {
            title: 'Revenue',
            dataIndex: 'revenue',
            width: '15%',
        },
        {
            title: 'ADR',
            dataIndex: 'adr',
            width: '15%',
        },
        {
            title: 'RevPAR',
            dataIndex: 'revPar',
            width: '15%',
        },
        {
            title: 'Additional Spend',
            dataIndex: 'additionalSpend',
            width: '15%',
        },
        {
            title: 'TRevPAR',
            dataIndex: 'trevPar',
            width: '15%',
        },
    ];
    const initial = [
        {
            key: '0',
            rowHeader: 'Without Group',
            rooms: '0',
            revenue: '0',
            adr: '0',
            revPar: '0',
            additionalSpend: '0',
            trevPar: '0',
            id: 0,
            wash: '0',
        },
        {
            key: '1',
            rowHeader: 'With Group',
            rooms: '0',
            revenue: '0',
            adr: '0',
            revPar: '0',
            additionalSpend: '0',
            trevPar: '0',
            id: 1,
            wash: '0',
        },
    ];

    const [dataSource, setDataSource] = useState(initial);

    useEffect(() => {
        if (formData !== dataSource) {
            setDataSource(formData);
        }
    }, [formData]);

    return (
        <div>
            <Table bordered rowKey="id" dataSource={[...dataSource]} columns={cols} pagination={false} />
        </div>
    );
};

export default SummaryTable;
